import axios from 'axios';
import Constants from '../constants';
import { ITrendGroup } from '../models/ITrendGroup';

export function getTrendGroupQuery(surveyId: number) {
	const url = Constants.API_TREND_GROUPS_URL.replace('{surveyId}', surveyId.toString());
	return url;
}

export async function get(surveyId: number): Promise<ITrendGroup[]> {
	const res = await axios.get(getTrendGroupQuery(surveyId), { headers: { Pragma: 'no-cache' } });
	return res.data;
}
